import React from 'react';
import { AssistantChatPanel, AssistantSuggestion } from '../../../../../components/AssistantPanel/AssistantChatPanel';
import {
  BanIcon,
  ClockIcon,
  HelpIcon,
  ReceiptIcon,
  UsersIcon,
} from '../../../../../components/AssistantPanel/assistant-panel-icons';
import { posAssistantService } from '../../../../../services/pos-assistant/pos-assistant.service';

// Every chip must be answerable end-to-end with no extra input from the user.
const SUGGESTIONS: AssistantSuggestion[] = [
  { text: 'מה קרה עם ההזמנה האחרונה שנסגרה?', Icon: ReceiptIcon },
  { text: 'מי ביטל פריטים במשמרת הנוכחית?', Icon: BanIcon },
  { text: 'אילו הזמנות פתוחות עכשיו?', Icon: ClockIcon },
  { text: 'מה קרה במשמרת הנוכחית?', Icon: UsersIcon },
  { text: 'איך עושים החזר ללקוח?', Icon: HelpIcon },
];

type PosAssistantPanelProps = {
  tenantId: string;
  employeeSession: string | null;
  opened: boolean;
  onClose: () => void;
};

export const PosAssistantPanel: React.FC<PosAssistantPanelProps> = ({ tenantId, employeeSession, opened, onClose }) => (
  <AssistantChatPanel
    testIdPrefix="pos-assistant"
    title="צאט תמיכה - 24/7"
    subtitle="שאלו על הזמנה, על פעולה של עובד או איך עושים משהו"
    statusLabel="מחובר לקופה"
    placeholder="שאל על הזמנה או על פעולה בקופה..."
    suggestions={SUGGESTIONS}
    opened={opened}
    onClose={onClose}
    canAsk={Boolean(employeeSession)}
    ask={(question, history, signal) => posAssistantService.ask(tenantId, employeeSession ?? '', question, history, signal)}
    sendFeedback={(message) => posAssistantService.sendFeedback(tenantId, employeeSession ?? '', message)}
    zIndex={302}
    feedbackZIndex={303}
  />
);
